/**
 * Листы комплекта РД из поля подтверждения даты: «1, 2, 5-7». Пусто — комплект целиком
 * (`undefined`, поле на сервер не уходит). Нераспознанный ввод — ошибка с подсказкой: молча в
 * «комплект целиком» он не превращается — разрешение отдельных листов иначе распространилось
 * бы на весь комплект. Модуль без импортов значений — проверяется node:test.
 */
export function parsePages(value: string): number[] | undefined {
  const text = value.trim();
  if (!text) return undefined;
  const pages = new Set<number>();
  for (const raw of text.split(/[,;]/)) {
    const part = raw.trim();
    if (!part) continue;
    const match = /^(\d{1,6})(?:\s*[-–—]\s*(\d{1,6}))?$/.exec(part);
    if (!match) {
      throw new Error(
        `Листы: «${part}» — не номер листа и не диапазон. Пример: 1, 2, 5-7; пусто — комплект целиком`,
      );
    }
    const from = Number(match[1]);
    const to = match[2] === undefined ? from : Number(match[2]);
    if (from < 1 || to < from || to - from >= 2000) {
      throw new Error(`Листы: диапазон «${part}» не подходит — номера с 1, от меньшего к большему`);
    }
    for (let page = from; page <= to; page += 1) pages.add(page);
  }
  if (!pages.size) {
    throw new Error('Листы: укажите номера листов или оставьте поле пустым — для комплекта целиком');
  }
  return [...pages].sort((a, b) => a - b);
}
